import EmailIcon from '@mui/icons-material/Email';
import { SubscriptionsList } from './SubscriptionsList';
import { SubscriptionsEdit } from './SubscriptionsEdit';

const subscriptions = {
  list: SubscriptionsList,
//   create: CategoryCreate,
  edit: SubscriptionsEdit,
  icon: EmailIcon,
};

export default subscriptions;
